import { useContext, useState } from 'react'

import { Modal } from '@clientbase/clientbase-library'
import { useActiveMerchantForRecord } from 'lib/merchant-group'
import { ChargeContext } from 'templates/Charge/context'

import ModalInvoiceDetailsContent from './ModalInvoiceDetailsContent'

const ModalInvoiceDetails = () => {
  const { modal, toggleModal, updateTable } = useContext(ChargeContext)
  const [fullHeight, setFullHeight] = useState<boolean>(false)

  // SC-10999: aberto da lista agregada do grupo, age na empresa da nota
  useActiveMerchantForRecord(modal.detailInvoice ? modal.uuid : undefined)

  return (
    <>
      <Modal
        handleClose={() => {
          toggleModal('detailInvoice')
          setFullHeight(false)
        }}
        disablePortal={false}
        open={modal.detailInvoice}
        width="100%"
        maxWidth="85vw"
        maxHeight="90vh"
        {...(fullHeight && { height: '100%' })}
      >
        <ModalInvoiceDetailsContent
          uuid={modal.uuid}
          handleReloadTable={updateTable}
          handleCloseModal={() => {
            toggleModal('detailInvoice')
            setFullHeight(false)
          }}
          setFullHeight={setFullHeight}
        />
      </Modal>
    </>
  )
}

export default ModalInvoiceDetails
